import React from 'react'

import * as moment from 'moment'
import {GRUPOCOMPROBANTEGROUP} from "./enum/grupoComprobGroups";

export function numberFormat(num) {
    if (!num) return 0
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    //return num;
}

export function numberCompleteFormat(num) {
    if (!num) return '0.00'
    if (num === 0) return '0.00'
    num = decimalFormat(parseFloat(num))
    return num.toString().replace(/(\d)(?=(\d{6})+(?!\d))/g, '$1,')
    //return num;
}

export function decimalFormat(num) {
    if (!num) return 0
    return `${parseFloat(num).toFixed(2)}`
}

export function padNumber(num, length) {
    if (num === null || num === undefined || num === '') return ''
    return num.toString().padStart(length, '0')
}

export function numberReactFormat(num) {
    if (!num || num === '' || num === undefined) return 0
    return parseFloat(num)
}

export function localdatetime(date) {
    if (!date) return ''
    return moment(date).format('YYYY-MM-DD')
}

export function DD_MM_YYYY_Format(date) {
    if (!date) return ''
    const NewDate = moment(date).format('DD/MM/YYYY')
    return NewDate
}

export function fechaHoraFormat(date) {
    const NewDate = moment(date).format('DD/MM/YYYY HH:mm:ss')
    return NewDate
}

export function horaFormat(date) {
    const NewDate = moment(date).format('HH:mm:ss')
    return NewDate
}

export function fechaCortaFormat(date) {
    const NewDate = moment(date).format('DD/MM/YYYY')
    return NewDate
}

// formato completo miercoles 17 de junio de 2020
export function fechaCompleta(date) {
    if (!date) {
        return ''
    }
    const monthArray = {
        0: 'Enero',
        1: 'Febrero',
        2: 'Marzo',
        3: 'Abril',
        4: 'Mayo',
        5: 'Junio',
        6: 'Julio',
        7: 'Agosto',
        8: 'Septiembre',
        9: 'Octubre',
        10: 'Noviembre',
        11: 'Diciembre'
    }
    moment.locale('es')
    var mes = moment(date).month()
    let mesS = monthArray[parseInt(mes)]
    let fecha = moment(date).format('DD')
    let anio = moment(date).format('YYYY')
    let fechaCompleta = fecha + ' de ' + mesS.toLowerCase() + ' de ' + anio
    return fechaCompleta
}

export const tiposCuenta = [
    { id: 'AH', descripcion: 'AHORRO' },
    { id: 'CC', descripcion: 'CORRIENTE' }
];

export const maskAccount = account =>
    account && account.length ? account.replace(/\d(?=\d{3})/g, 'X') : 'XXXXXX'

export const validateCuentaContable = number => {
    const re = /^[1-9]{1}[.][1-9]{1}[.][0-9]{2}[.][0-9]{2}[.][0-9]{2}[.][0-9]{2}$/
    return re.test(number)
}

export const validateOnlyNumbers = number => {
    const re = /^\d{0,20}$/
    return re.test(number)
}

export const validateLetters = letter => {
    const re = /^[a-zA-Z Ññ]*$/
    return re.test(letter)
}

export const validateNumbers = number => {
    const re = /^\d+$/
    return re.test(number)
}

export const validateAlphanumeric = number => {
    const re = /^[a-zA-Z0-9 _\-,:/.ñÑáéíóúÁÉÍÓÚ]*$/
    return re.test(number)
}

export const validateAlphanumericRestrict = number => {
    const re = /^[a-zA-Z0-9]*$/
    return re.test(number)
}

export const validateEmail = number => {
    const re = /\S+@\S+\.\S+/
    return re.test(number)
}

export const validateDocumentId = number => {
    const re = /^\d{0,13}$/
    return re.test(number)
}

export const fixFloat = money => {
    let twoPlacedFloat = parseFloat(money).toFixed(2)
    return twoPlacedFloat
}

export const validateMoney = money => {
    const re = /^\d+(\.\d{1,2})?$/
    return re.test(money)
}


export const dateFormat = (date) => {
    let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = "" + d.getFullYear();

    if (month.length < 2) {
        month = "0" + month;
    }
    if (day.length < 2) {
        day = "0" + day;
    }

    return [year, month, day].join("-");
};

export const ddmmyyyyToIso = (dateStr) =>{
    if (!dateStr) return '';
    const parts = dateStr.split('/');
    if (parts.length !== 3) return '';
    const [dd, mm, yyyy] = parts.map(p => p.trim());
    // validación básica
    if (!dd || !mm || !yyyy) return '';
    const ddP = dd.padStart(2, '0');
    const mmP = mm.padStart(2, '0');
    return `${yyyy}-${mmP}-${ddP}`;
}

export const sentenceCase = str => {
    return str
        .replace(/[a-z]/i, function (letter) {
            return letter.toUpperCase()
        })
        .trim()
}

export const localizationTable = () => {
    const parametros = {
        pagination: {
            labelRowsPerPage: 'Filas por página:',
            labelRows: 'filas',
            labelDisplayedRows: 'Registros',
            firstAriaLabel: 'Primera Página',
            firstTooltip: 'Primera Página',
            previousAriaLabel: 'Página Anterior',
            previousTooltip: 'Página Anterior',
            nextAriaLabel: 'Siguiente Página',
            nextTooltip: 'Siguiente Página',
            lastAriaLabel: 'Última Página',
            lastTooltip: 'Última Página'
        },
        toolbar: {
            nRowsSelected: '{0} registro(s) seleccionados',
            searchPlaceholder: 'Buscar'
        },
        header: {
            actions: 'Acción'
        },
        grouping: {
            placeholder: 'Arrastre una columna para filtrar.',
            groupedBy: 'Agrupado por: '
        },
        body: {
            emptyDataSourceMessage: 'No existen registros',
            filterRow: {
                filterTooltip: 'Filtrar Datos Tabla'
            },
            addTooltip: 'Agregar',
            deleteTooltip: 'Borrar',
            editTooltip: 'Editar',
            editRow: {
                deleteText: '¿Esta seguro que desea borrar este registro?'
            }
        }
    }
    return parametros
}

export const estados = () => {
    const estado = {
        S: 'SI',
        N: 'NO'
    }
    return estado
}

export const tipoBase = () => {
    const estado = {
        P: 'Principal',
        C: 'Contingente'
    }
    return estado
}

export const estadosObject = () => {
    const estados = [
        {codigo: 'S', descripcion: 'SI'},
        {codigo: 'N', descripcion: 'NO'}
    ]
    return estados
}

export const SiNoObject = () => {
    const estados = [
        {codigo: 'N', descripcion: 'NO'},
        {codigo: 'S', descripcion: 'SI'},
        {codigo: 'T', descripcion: 'TODAS'}
    ]
    return estados
}
export const getEstado = estado => {
    if (estado === 'N') {
        return {codigo: 'N', descripcion: 'NO'}
    }
    if (estado === 'S') {
        return {codigo: 'S', descripcion: 'SI'}
    }
}

export const matchItem = parts => {
    return (
        <div>
            {parts.map((part, index) => (
                <span key={index} style={{fontWeight: part.highlight ? 700 : 400}}>
          {part.text}
        </span>
            ))}
        </div>
    )
}

export function formatFechaConsulta(date) {
    const NewDate = moment(date).format('YYYY-MM-DD')
    return NewDate
}

export const isEmpty = obj => {
    let rs = false
    if (obj instanceof Object) {
        if (Object.keys(obj).length === 0) {
            rs = true
        }
        if (obj === null || obj === undefined || obj === '') {
            rs = true
        }
    }
    return rs
}

export function DDMMYYYYFormat(date) {
    if (!date) return ''
    const NewDate = moment(date).format('DD/MM/YYYY')
    return NewDate
}

export const stepsCorresponsales = [
    'Datos Básicos',
    'Responsable de Oficina de Vecino Cooperativo',
    'Dirección y Contacto',
    'Tienda ID',
    'Dispositivos POS'
]

export const dInitMonth = () => {

    let date = new Date();

    let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        year = "" + d.getFullYear();

    if (month.length < 2) {
        month = "0" + month;
    }

    return [year, month, "01"].join("-");
};

export const roundTwoDecimal = (data) => {
    const number = parseFloat(data);
    if (isNaN(number)) return 0;
    // devolver Number (no string) con 2 decimales para evitar concatenaciones
    return Number(number.toFixed(2));
};

export const grupoComprobantes = [
    GRUPOCOMPROBANTEGROUP.FACTURAS_DE_VENTA,
    GRUPOCOMPROBANTEGROUP.COBRO_APORTES,
    GRUPOCOMPROBANTEGROUP.COBRO_CREDITO,
    GRUPOCOMPROBANTEGROUP.COBRO_MULTAS,
    GRUPOCOMPROBANTEGROUP.COBRO_VENTAS,
    GRUPOCOMPROBANTEGROUP.COBRO_CREDITO,
]

export const grupoComprobantesReporte = [
    { id: -1, codigo: 'TOD', descripcion: 'TODOS'},
    GRUPOCOMPROBANTEGROUP.APORTE_SOCIO,
    GRUPOCOMPROBANTEGROUP.MULTA_SOCIO,
    GRUPOCOMPROBANTEGROUP.CREDITO_A_SOCIO,
]
